// @ts-nocheck

import React from 'react';
import { useMemo } from 'react';
import { Link as RRDLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

const sharedStyle = css`
  font-weight: normal;
  display: block;

  &:focus {
    outline: none;
  }
`;

const StyledNativeLink = styled.a`
  ${sharedStyle}
`;

const StyledLink = styled(RRDLink)`
  ${sharedStyle}
`;
type LinkProps = HTMLAnchorElement & {
  children?: React.ReactNode;
  external?: boolean;

  readonly className?: string;
  readonly to: string | object;
  readonly replace?: boolean;
};

/**
 * @description Use this component instead of using directly Link from react-router-dom lib
 *
 * @param {Node} children Children
 * @param {boolean} external Should link opens in another tab or not
 * @param {Array<unknown>} rest Any possible prop descending from react-router-dom Link or HTMLAnchorElement
 * @returns React component
 */

const Link = ({ children, external = false, ...rest }: LinkProps) => {
  const { to } = rest;
  const linkOptions = useMemo(
    () => ({
      target: external ? '_blank' : undefined,
      rel: external ? 'noreferrer' : undefined,
      ...rest,
    }),
    [external, rest],
  );

  if (to) {
    return <StyledLink {...linkOptions}>{children ?? null}</StyledLink>;
  }

  return <StyledNativeLink {...linkOptions}>{children}</StyledNativeLink>;
};

export default Link;
